import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const colors = {
  coral: '#E8847C',
  coralLight: '#F5AEA8',
  mint: '#7ECEC1',
  mintLight: '#b8e4dd',
  cream: '#FFF9F5',
  warmGray: '#4A4543',
};

const newsItems = [
  {
    slug: '/news/donor-story',
    date: '2026年5月20日',
    category: 'ストーリー',
    title: 'あたため続けた100万円が、未来への希望になった日',
    subtitle: '― 受け継がれた想いが、次の誰かへ羽ばたく ―',
    excerpt:
      '国際女性デーチャリティイベントを通じてご縁をいただいた歯科医師の先生へ感謝のセレモニーを執り行いました。叔父様から贈られた100万円を、誰かの未来へつなげたい——その想いの物語をご紹介します。',
    image: '/images/donor-story-ceremony.png',
    imageAlt: '感謝のセレモニーの様子',
  },
  {
    slug: '/#completion-report',
    date: '2026年5月',
    category: 'ご報告',
    title: '国際女性デーチャリティイベント事業完了のご報告',
    subtitle: '【御礼とご報告】',
    excerpt:
      '2026年3月14日開催のイベントは無事終了いたしました。収支差額の活用計画を含む事業完了報告書をご報告申し上げます。',
    image: null,
    imageAlt: '',
    external: false,
    isHashLink: true,
  },
];

export default function News() {
  return (
    <div
      className="min-h-screen bg-white overflow-x-hidden"
      style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}
    >
      <Header variant="event" />

      <main className="pt-24">
        <section className="relative py-14 sm:py-20 overflow-hidden" style={{ backgroundColor: colors.cream }}>
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <span
              className="inline-block px-4 py-1.5 text-xs font-bold tracking-[0.18em] uppercase mb-5"
              style={{ backgroundColor: `${colors.mintLight}60`, color: colors.mint, borderRadius: '100px' }}
            >
              News
            </span>
            <h1
              className="text-4xl sm:text-5xl font-black tracking-tight"
              style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif" }}
            >
              お知らせ
            </h1>
            <p className="mt-4 text-gray-600">イベントのご報告や、ご支援者のストーリーをお届けします。</p>
          </div>
        </section>

        <section className="py-12 sm:py-16">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
            {newsItems.map((item) => {
              const cardContent = (
                <>
                  {item.image && (
                    <div className="sm:w-48 flex-shrink-0 rounded-xl overflow-hidden bg-gray-100 aspect-[4/3] sm:aspect-auto sm:min-h-[140px]">
                      <img src={item.image} alt={item.imageAlt} className="w-full h-full object-cover" />
                    </div>
                  )}
                  <div className="flex-1 min-w-0 p-5 sm:p-6">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span
                        className="text-xs font-bold px-2.5 py-0.5 rounded-full"
                        style={{ backgroundColor: `${colors.coralLight}50`, color: colors.coral }}
                      >
                        {item.category}
                      </span>
                      <time className="text-xs text-gray-500">{item.date}</time>
                    </div>
                    {item.subtitle && (
                      <p className="text-xs font-bold mb-1" style={{ color: colors.mint }}>
                        {item.subtitle}
                      </p>
                    )}
                    <h2
                      className="text-lg sm:text-xl font-black leading-snug mb-2 group-hover:opacity-80 transition-opacity"
                      style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif" }}
                    >
                      {item.title}
                    </h2>
                    <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">{item.excerpt}</p>
                    <span
                      className="inline-flex items-center gap-1 mt-4 text-sm font-bold"
                      style={{ color: colors.mint }}
                    >
                      続きを読む
                      <i className="ri-arrow-right-line" aria-hidden />
                    </span>
                  </div>
                </>
              );

              const className =
                'group flex flex-col sm:flex-row gap-0 sm:gap-0 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5';

              if (item.isHashLink) {
                return (
                  <a key={item.slug} href={item.slug} className={className}>
                    {cardContent}
                  </a>
                );
              }

              return (
                <Link key={item.slug} to={item.slug} className={className}>
                  {cardContent}
                </Link>
              );
            })}
          </div>

          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm font-bold text-gray-500 hover:opacity-70 transition-opacity"
            >
              <i className="ri-arrow-left-line" aria-hidden />
              トップページへ
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
